import { useState } from 'react';
import { toast } from 'react-toastify';
import fleetApi from '../../services/api.service';
import { getConsignmentRuleApiErrorMessage } from '../../utils/consignment-rule.util';

export default function useUpdateConsignmentRule() {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(null);

  const updateConsignmentRule = async (id, payload) => {
    setIsSuccess(null);
    try {
      setIsLoading(true);
      const response = await fleetApi.put(`/consignment-rule/${id}`, payload);
      setIsSuccess(true);
      toast.success(
        response.data?.message || 'Règle de consigne mise à jour avec succès.'
      );
    } catch (error) {
      setIsSuccess(false);
      toast.error(getConsignmentRuleApiErrorMessage(error));
    } finally {
      setIsLoading(false);
    }
  };

  return { isLoading, isSuccess, updateConsignmentRule };
}
